import { render, staticRenderFns } from "./ClassHead.vue?vue&type=template&id=97d28c30&scoped=true&lang=pug&"
import script from "./ClassHead.vue?vue&type=script&lang=js&"
export * from "./ClassHead.vue?vue&type=script&lang=js&"
import style0 from "./ClassHead.vue?vue&type=style&index=0&id=97d28c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d28c30",
  null
  
)

export default component.exports